import { BakeryEvent } from '../types/event'

// Halloweenvecka 44 · 26 oktober – 1 november 2026
export const events: BakeryEvent[] = [
  {
    id: 'halloween-start',
    title: 'Halloweenveckan drar igång!',
    date: '2026-10-26',
    time: 'Under öppettiderna',
    category: 'Happening',
    description:
      'Vi tänder ljusen, pyntar Toppen och fyller diskarna med spökligt goda nyheter. Kom och känn Halloweenstämningen hos oss!',
  },
  {
    id: 'halloween-run-club',
    title: 'Run Club',
    date: '2026-10-27',
    time: 'Starttid meddelas',
    category: 'Löpning',
    description:
      'För vuxna som gillar rörelse, gemenskap och riktigt god mat! Vi springer tillsammans och avslutar med en härlig pinsabuffé på Toppen.',
    details: ['Avslutning: pinsabuffé på Toppen'],
    signup: true,
    ctaLabel: 'Boka din plats',
  },
  {
    id: 'halloween-hidden-reality',
    title: 'Toppen Hidden Reality',
    date: '2026-10-28',
    time: 'Tid meddelas',
    category: 'Upplevelse',
    description:
      'En unik kväll där verklighet och fantasi möts. Njut av en spännande upplevelse, pinsabuffé och bubbel på Toppen.',
    details: ['Ingår: Hidden Reality, pinsabuffé och bubbel'],
    signup: true,
    ctaLabel: 'Boka din plats',
  },
  {
    id: 'halloween-barnens-dag',
    title: 'Barnens dag',
    date: '2026-10-29',
    time: '11:00–13:00',
    category: 'För barn',
    description:
      'En magisk dag för alla barn med massor av roliga aktiviteter! Kom utklädd – det blir ansiktsmålning, fotovägg, pannkaksbuffé & våfflor, Halloween-mandala, monsterbun och godisregn.',
    details: ['Halloweenlopp kl 13:30 – start vid Toppen, kom utklädd!'],
    signup: true,
    ctaLabel: 'Köp biljett',
  },
  {
    id: 'halloween-monsterdisko',
    title: 'Monsterdisko',
    date: '2026-10-30',
    time: '18:00–20:00',
    category: 'Fest',
    description:
      'Efter Växjö Citys Zoombiewalk fortsätter festen på Toppen! Dans, musik och massor av Halloweenstämning.',
    details: ['För alla – kom utklädd!'],
  },
  {
    id: 'halloween-pa-toppen',
    title: 'Halloween på Toppen',
    date: '2026-10-31',
    time: 'Tid meddelas',
    category: 'Happening',
    description:
      'Självaste Halloween! En dag fylld med spökliga överraskningar, goda smaker och härlig stämning för alla åldrar. Kom utklädd och upplev en magisk dag hos oss!',
  },
  {
    id: 'halloween-hostbrunch',
    title: 'Höstbrunch',
    date: '2026-11-01',
    time: '11:00–16:00',
    category: 'Brunch',
    description:
      'Vi avslutar Halloweenveckan med en mysig höstbrunch på Toppen. Njut av god mat, härlig stämning och den perfekta avslutningen på en spökligt bra vecka!',
    signup: true,
    ctaLabel: 'Boka bord',
  },
]
